import React, { useCallback, useMemo, useState } from "react";
import { TextField } from "@mui/material";
import { SxProps } from "@mui/material";
import { Theme } from "@mui/material";

export interface DecimalAdapterProps {
    label: string
    value?: number
    sx?: SxProps<Theme>
    onChange: (value: number) => void
}

class DecimalParser {
    applyMask(value: string): string {
        if (!value) return 'R$ 0,00';

        let newValue = value.replace(/\D/g, '');
        newValue = newValue.padStart(3, '0');
        newValue = newValue.replace(/(\d{2})$/, ',$1');
        newValue = newValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');

        newValue = newValue.replace(/^0+(?!\.|$)/, '');

        if (newValue.startsWith(',')) {
            newValue = '0' + newValue;
        }

        return `R$ ${newValue}`;
    }

    format(value: number|undefined): string {
        if (!value) return 'R$ 0,00';
        // value vem em reais (ex: 100 = R$ 100,00); applyMask espera centavos.
        return this.applyMask(Math.round(value * 100).toString());
    }

    parse(value: string): number | null {
        let newValue = value.replace(/\D/g, '');
        newValue = newValue.replace(",", ".");
        return Number(newValue) / 100;
    }
}

const CurrencyTextField: React.FC<DecimalAdapterProps> = ({ label, value, sx, onChange }) => {
    const decimalParser = useMemo(() => new DecimalParser(), []);
    const [fieldValue, setFieldValue] = useState<string>(decimalParser.format(value));

    const handleValueChange = useCallback((newValue: string) => {
        const maskedValue = decimalParser.applyMask(newValue);
        setFieldValue(maskedValue);

        const parsedValue = decimalParser.parse(maskedValue) || 0;
        onChange(parsedValue);
    }, [decimalParser, onChange]);

    return (
        <TextField
            sx={sx}
            id={`form_${label}`}
            label={label}
            value={fieldValue}
            onChange={event => handleValueChange(event.target.value || "")}
        />
    );
};

export default CurrencyTextField;